import GlobalStyle from './../src/globalStyles'
import './App.scss';
import UserContextProvider from './contexts/UserContext'
import AppRoutes from './AppRoutes'

function App() {
  /* eslint-disable react-hooks/exhaustive-deps */
  return (
    <UserContextProvider>
      <GlobalStyle/>
      <div className="App">
        <AppRoutes />
      </div>
    </UserContextProvider>
  );
}

export default App;
